import ErrorMessage from "@components/ErrorMessage"
import { defaultApiErrorMessage } from "@utils/textDefaults"
import { TitleValueList } from "@components/TitleValueList/TitleValueList"
import { Card, CardHeader, CardTitle, CardContent } from "@components/ui/card"
import { DataTable } from "@components/DataTable/DataTable"
import { useGetAccountNumberHistoryQuery } from "@apis/accounts/useAccounts"
import { useGetPtcHistoryQuery } from "@apis/pricing/usePricing"
import { SetAccountNumberForm } from "@components/AccountUtilityHistory/SetAccountNumberForm"
import { useAccountUtilityHistorySerializer } from "./utils/accountUtilityHistorySerializerSchema"
import {
  accountNumberHistoryColumns,
  ptcHistoryColumns,
} from "./utils/tableColumnsSchema"

type TAccountUtilityHistoryProps = {
  account_id: string
}
export const AccountUtilityHistory = ({
  account_id,
}: TAccountUtilityHistoryProps) => {
  const {
    data: accountNumberHistoryData,
    isError: accountNumberHistoryIsError,
  } = useAccountUtilityHistorySerializer(account_id)

  const getAccountNumberHistory = useGetAccountNumberHistoryQuery(account_id)

  const getPtcHistory = useGetPtcHistoryQuery(
    accountNumberHistoryData.market_code,
    accountNumberHistoryData.revenue_class_code,
  )
  return (
    <div className="tw:flex tw:flex-col tw:gap-4">
      {accountNumberHistoryIsError ? (
        <ErrorMessage message={defaultApiErrorMessage} />
      ) : (
        <TitleValueList
          items={accountNumberHistoryData.items}
          variant="gridClean"
        />
      )}
      <Card>
        <CardHeader>
          <CardTitle className="tw:text-2xl tw:font-bold">
            Account Number History
          </CardTitle>
        </CardHeader>
        <CardContent>
          <SetAccountNumberForm account_id={account_id} />
          <DataTable
            pending={getAccountNumberHistory.isPending}
            columns={accountNumberHistoryColumns}
            data={getAccountNumberHistory.data ?? []}
            condensed
          ></DataTable>
        </CardContent>
      </Card>
      <Card>
        <CardHeader>
          <CardTitle className="tw:text-2xl tw:font-bold">
            Price To Compare History
          </CardTitle>
        </CardHeader>
        <CardContent>
          <DataTable
            pending={getPtcHistory.isPending}
            columns={ptcHistoryColumns}
            data={getPtcHistory.data ?? []}
            condensed
          ></DataTable>
        </CardContent>
      </Card>
    </div>
  )
}
